import type { AxiosError } from 'axios';
import type { DocumentPickerAsset } from 'expo-document-picker';
import type { ImagePickerAsset } from 'expo-image-picker';
import { Platform } from 'react-native';
import { createMutation } from 'react-query-kit';

import { client } from '../common';
import type { Reservation } from './types';

type Variables = {
  id: number;
  images: ImagePickerAsset[] | DocumentPickerAsset[];
};
export type UploadTripPhotos = {
  data: Reservation;
};

export const useUploadTripPhotos = createMutation<
  UploadTripPhotos,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) => {
    const formData = new FormData();

    variables.images.forEach(
      (image: ImagePickerAsset | DocumentPickerAsset) => {
        if (Platform.OS === 'web') {
          formData.append('images[]', image); // Append the file object directly for web
        } else {
          formData.append('images[]', {
            uri: image.uri,
            name: image.fileName || image.name,
            type: image.mimeType || 'image/jpeg',
          });
        }
      }
    );

    return client({
      url: `v2/reservations/${variables.id}/upload-photos`,
      method: 'POST',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        console.error('yoyo', err);
        throw new Error(err.response.data.errors.join(', '));
      });
  },
});
